import { ref, shallowRef, triggerRef } from "vue"

export function useVoucherData(program = "core") {
  const vouchers = shallowRef([])
  const loading = ref(false)
  const error = ref(null)

  async function load() {
    loading.value = true
    error.value = null

    try {
      const url = program === "sore" ? "/api/vouchers/sore" : "/api/vouchers/core"

      const controller = new AbortController()
      const timeoutMs = program === "sore" ? 120_000 : 30_000
      const timeout = setTimeout(() => controller.abort(), timeoutMs)
      const res = await fetch(url, { signal: controller.signal })
      clearTimeout(timeout)

      if (!res.ok) throw new Error(`HTTP ${res.status}`)

      const data = await res.json()
      vouchers.value = data
      triggerRef(vouchers)
      // console.log(`Loaded ${vouchers.value.length} ${program} vouchers`)
    } catch (e) {
      if (e.name === "AbortError") {
        error.value = "Request timed out"
      } else {
        error.value = e?.message || String(e)
      }
      vouchers.value = []
      triggerRef(vouchers)
      console.error("Voucher load failed:", e)
    } finally {
      loading.value = false
    }
  }

  return { vouchers, loading, error, load }
}

// import { ref } from "vue"

// export function useVoucherData(program = "core") {
//   const vouchers = ref([])
//   const loading = ref(false)
//   const error = ref(null)

//   async function load() {
//     loading.value = true
//     error.value = null

//     try {
//       const url = program === "sore" ? "/api/vouchers/sore" : "/api/vouchers/core"

//       const controller = new AbortController()
//       const timeoutMs = program === "sore" ? 120_000 : 30_000
//       const timeout = setTimeout(() => controller.abort(), timeoutMs)
//       const res = await fetch(url, { signal: controller.signal })
//       clearTimeout(timeout)

//       if (!res.ok) throw new Error(`HTTP ${res.status}`)

//       vouchers.value = await res.json()
//       console.log(`Loaded ${vouchers.value.length} ${program} vouchers`)
//     } catch (e) {
//       if (e.name === "AbortError") {
//         error.value = "Request timed out"
//       } else {
//         error.value = e?.message || String(e)
//       }
//       vouchers.value = []
//       console.error("Voucher load failed:", e)
//     } finally {
//       loading.value = false
//     }
//   }

//   return { vouchers, loading, error, load }
// }
